import React from "react";
import "./Apartemen.scss";
import data from "./data.json";
import Card from "../../Component/Landscape/Landscape";
import MTownResimages from "../../Media/Apartemen Sumser/MTown Residence/MTownRes";
import MTownSigimages from "../../Media/Apartemen Sumser/MTown Signature/MTownSig";
import Rainbowimages from "../../Media/Apartemen Sumser/Rainbow Spring/RainbowSpring";

const imageMap = {
  MTownResimages,
  MTownSigimages,
  Rainbowimages,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div className="produkapart">
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
